// extracted by mini-css-extract-plugin
module.exports = {"shape-wrap":"_3HofyA"};